import React from "react";
import "./styles.css";
//import { AiOutlineSearch } from "react-icons/ai";
import SideNav from './../../../components/SideNav_RI';
import DisplayInfoRIPerfil from './../../../components/Display_RepresentanteDeInstituição/DisplayPerfilRI';
import TableHorarios from './../../../components/TableHorarios';

var id = localStorage.getItem("id_agent")

export default function RI_Perfil() {
    return (
        <>
            <SideNav />
           <div id="top-RI-Cadastro"/>
            <div id="main-RI-ListaPacientes">
                    <p id="RI-ListaPacientes">Perfil do(a) Repesentante de Instituição</p>
                    <hr id="divider-RI-ListaPacientes" />
                    <br></br>
                    <h1 className="RIDisplayInfo-Tittle">Dados do Perfil</h1>
                    <hr className="divider-RI-ListaPacientes-Dashed" /> 
                    <DisplayInfoRIPerfil/>
                    <br></br>
                    <h1 className="RIDisplayInfo-Tittle">Agenda de horários já ocupados da Instituição</h1>
                    <hr className="divider-RI-ListaPacientes-Dashed" /> 
                    <TableHorarios agent_id={id}/>
                    <br></br>
                    <br></br>
           </div>
        </>
    );
}